<script>
	import { fade } from 'svelte/transition'
	import sidePanel from 'side-panel-menu-thing'

	export let content = ''

	let startingHeight = 265
	// let height = startingHeight
	let contentHeight = 0

	let expanded = false

	$: height = expanded ? contentHeight : startingHeight

	const bioPanel = new sidePanel({
		target: document.body,
		props: {
			target: document.body,
			content: document.getElementById('bio'),
			width: 680,
			duration: 580,
			left: true,
		},
	})
</script>

<div class="main">
	<div class="inner-wrap">
		<div class="intro">
			<div class="auth">
				<img
					src="/wp-content/uploads/2020/09/kevin-opt.jpg"
					alt="Kevin Gallagher" />
				<div>
					<h4>Author</h4>
					<h3>Kevin Gallagher</h3>
					<button class="btn outline red-outline" on:click={bioPanel.show}>
						Read Bio
					</button>
				</div>
			</div>

			<div class="intro-content" class:expanded>
				<article>
					<h1>Teach Your Kid To Hit... So They Don’t Quit!</h1>
					<div class="intro-content-content" style="padding-bottom: {height}px">
						{#if !expanded}
							<div
								class="white-fade"
								in:fade={{ duration: 600 }}
								out:fade={{ duration: 800 }} />
						{/if}
						<div bind:clientHeight={contentHeight}>
							{@html content}
						</div>
					</div>
				</article>
				<div class="read-more">
					<button on:click={() => (expanded = !expanded)}>
						Read More <span>
							<svg>
								<path
									d="M10.383,17.143 L19.892,0.683 L0.864,0.683 L10.383,17.143 Z" />
							</svg>
							<svg>
								<path
									d="M10.383,17.143 L19.892,0.683 L0.864,0.683 L10.383,17.143 Z" />
							</svg>
						</span>
					</button>
					<a
						href="https://www.amazon.com/dp/1734727101?ref_=pe_3052080_397514860"
						class="btn red">
						Purchase Book
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
